'use client';

import type { BlogSearchProps } from '@routeroyal/theme-core';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

/**
 * AllysBlogSearch - Allys-themed blog search
 * Search input with Allys navy focus ring and Inter font
 */
export function AllysBlogSearch({
  value = '',
  onChange,
  placeholder = 'Search articles...',
  className = '',
}: BlogSearchProps) {
  return (
    <div className={`relative [font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe_UI',system-ui,sans-serif] ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <MagnifyingGlassIcon className="h-5 w-5 text-[#243462]/60" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          w-full pl-10 pr-4 py-3 
          border-2 border-gray-200 
          rounded-xl 
          focus:ring-2 
          focus:ring-[#BBA339] 
          focus:border-[#BBA339]
          transition-all
          placeholder:text-gray-400
          bg-white
          hover:border-gray-300
        "
      />
    </div>
  );
}

